<div class="d-flex flex-column align-items-center">
  <div *ngIf="loading">
    <mat-spinner diameter="150" mode="indeterminate"></mat-spinner>
  </div>
  <div *ngIf="!loading" class="main-part">

    <div *ngIf="status=='validate_email'" class="d-flex flex-column password-part">
      <h2 @loginItem>Please validate your email:</h2>
      <form (submit)="validateEmail()" class="form-inline p-0" [formGroup]="emailForm" >
        <app-alert [message]="message" [type]="messageType" @loginItem></app-alert>
        <div class="login-input-container" @loginItem>
          <label class="sr-only" for="email">Password</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><img src="./assets/ui/svg/grey/icon-email.svg"/></div>
            </div>
            <div class="vertical-divider"></div>
            <input type="email" id="email" name="email" placeholder="Insert your email address" #emailInput formControlName="email" autofocus>
          </div>
        </div>
        <button @loginItem type="submit" [class]="loading || !emailForm.valid ? 'non-active' : 'active'" [disabled]="loading || !emailForm.valid">Validate</button>
      </form>
    </div>

    <div *ngIf="status=='bad_token'" class="d-flex flex-column align-items-center">
      <h2>Wrong entry!</h2>
      <span class="normal-text">There is nothing here</span>
      <a class="share-medix-btn" href="https://sharemedix.com/contact/">Start using ShareMedix</a>
    </div>

    <div *ngIf="status=='error'" class="d-flex flex-column align-items-center">
      <h2>Something went wrong!</h2>
      <span class="normal-text">Try again!</span>
      <a class="share-medix-btn" (click)="reload()">Refresh</a>
    </div>

    <div *ngIf="status=='uploading'" class="d-flex flex-column align-items-center">
      <h2>Upload in progress</h2>

      <app-status-radial-bar [progressValue]="((uploadProgress * 0.65) + (createZipProgress * 0.3))*100" [nameLabel]="''" statusLabel=""
                             [insideLabel]="((uploadProgress * 0.65) + (createZipProgress * 0.3))*100 | number: '1.0-0'" status="uploading">
      </app-status-radial-bar>

    </div>

    <div *ngIf="status=='expired'" class="d-flex flex-column align-items-center expired-part">
      <h2>Empty!</h2>
      <span class="normal-text">Request expired or your link is inactive.</span>
      <a class="share-medix-btn" href="https://sharemedix.com/contact/">Start using ShareMedix</a>
    </div>

    <div *ngIf="status=='done'" class="d-flex flex-column align-items-center done-part">
      <h2>Done!</h2>
      <span class="normal-text"><span>Your data have been shared with </span><span class="blue-text"> {{receiverEmail}}</span></span>
      <img src="./assets/ui/svg/green/icon-check-correct-animated.svg">
      <a class="share-medix-btn" href="https://sharemedix.com/contact/">Start using ShareMedix</a>
    </div>

    <div *ngIf="status=='upload'" class="d-flex flex-column align-items-center upload-part">
      <h2 class="mb-1">ShareMedix Receiving</h2>
      <h3 class="text-center mb-1">{{receiverEmail}} <br> has asked you to upload DICOM data</h3>
      <span class="green-text mb-3">Please upload max. 3GB of data.</span>
      <form class="d-flex flex-column w-100 upload-form" [formGroup]="uploadMessageForm">
        <div class="d-flex flex-row flex-nowrap dropdown-zone" ng2FileDrop [uploader]="uploader" (onFileDrop)="dropped($event)">
          <div class="img">
            <img src="./assets/ui/svg/blue/icon-add.svg" (click)="clickOnUploadDicom()">
            <input type="file" class="hide" ng2FileSelect [uploader]="uploader" name="document" multiple id="upload-button" #uploadInput (change)="uploadDicom($event)" />
            <input type="file" class="hide" (change)="uploadDicoms(folderInput.files, $event)" id="upload-directory-button" #folderInput webkitDirectory>
          </div>
          <div class="d-flex flex-column justify-content-center upload-label">
            <span class="title-label">Upload DICOM files</span>
            <a class="smaller-label" (click)="clickOnUploadDicoms()" >Or select a folder</a>
          </div>
        </div>

        <div *ngIf="filesToUpload.length > 0" class="file-to-upload-container customScroll">
          <div *ngFor="let ftu of filesToUpload" class="file-to-upload">
            <div class="file-icon">
              <img [src]="(ftu.fileToProcess | keyvalue).length > 0 ? './assets/ui/svg/grey/icon-file-processing.svg' : ftu.fileAnonymised.length === 0 ? './assets/ui/svg/grey/icon-file-error.svg' : ftu.type === 'folder' ? './assets/ui/svg/grey/icon-directory.svg' : './assets/ui/svg/grey/icon-dicom-file.svg'">
            </div>
            <div class="file-label">
              <span class="file-title">{{ftu.name}}</span>
              <span class="file-size">{{ftu.size | fileSize}}</span>
            </div>
            <div class="d-flex flex-grow-1"></div>
            <div class="d-flex flex-row buttons">
              <div class="d-flex error" matTooltip="No medical data detected" *ngIf="(ftu.fileToProcess | keyvalue).length === 0 && ftu.fileAnonymised.length === 0">
                <img src="./assets/ui/svg/red/alert2.svg">
              </div>
              <a class="d-flex flex-column justify-content-center" (click)="deleteFileToUpload(ftu.id)">
                <mat-icon>close</mat-icon>
              </a>
            </div>
          </div>
        </div>

        <textarea placeholder="Your message (optional)" rows="6" formControlName="patientMessage"></textarea>
        <span class="text-center size-exceeded" *ngIf="totalSizeExceeded">The maximum transfer size has been exceeded. Make sure your files are no larger than 3GB.</span>
        <button class="d-flex flex-row justify-content-center align-items-center share-medix-btn" [disabled]="processingFiles || formEmpty || totalSizeExceeded" (click)="createZip()">
          <span *ngIf="processingFiles">Anonymizing files</span>
          <span *ngIf="!processingFiles">Send</span>
          <mat-spinner class="ml-2" color="accent" diameter="20" *ngIf="processingFiles"></mat-spinner>
        </button>
      </form>

    </div>
  </div>

</div>
